<div class="boxy">
  <div class="headingg container">
    <h2>Idea Name: {{ idea_name }}</h2>
    <h2 *ngIf="track_name != ''">Track: {{ track_name }}</h2>
  </div>
</div>
<form [formGroup]="myForm">
  <div class="container" id="1">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Venture Overview</h3>
      </div>
    </div>
    <div class="green full">
      <p>
        What is the name of your startup?
      </p>
      <div class="inputs">
        <div class="field">
          <textarea [formControl]="myForm.controls.ques1" rows="5"> </textarea>
        </div>
        <button class="green-button" mat-button (click)="onquesN(1)">
          Save
        </button>
        <button (click)="openPopup(1)" class="green-button" mat-button>
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[1] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: black">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(1)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
 
              <span class="headi">SAMPLE ANSWER</span>

            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>EcoTech Solutions
              </p>
            </div>
            <div class="container video">
              <div class="video">
     </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Venture Overview</h3>
      </div>
    </div>
    <div class="green">
      <p>
        Briefly describe your venture.
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques2" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(2)">
          Save
        </button>
        <button (click)="openPopup(2)" class="green-button" mat-button>
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[2] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(2)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
              <span class="headi">SAMPLE ANSWER</span>
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
            </h1>
          </div>
          <div style="color: white">
            <div class="member" style="color: black">
              <p>We develop eco-friendly packaging alternatives made from biodegradable materials.
              </p>

            </div>
            <div class="container video">
              <div class="video">
                <!-- <iframe
                  width="300"
                  src="https://www.youtube.com/embed/HTJKD6PzvVE"
                ></iframe> -->
             
              </div>
              <!-- </div>
                                        </div> -->
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Problem Identification</h3>
      </div>
    </div>
    <div class="green">
      <p>
        What problem is your venture trying to solve? 
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques3" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(3)">
          Save
        </button>
        <button (click)="openPopup(3)" class="green-button" mat-button>
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[3] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(3)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
             
              <p>
                Plastic pollution in packaging waste.
              </p>
            </div>
            <div class="container video">
              <div class="video">
                <!-- <iframe
                  width="300"
                  src="https://www.youtube.com/embed/wWpEiSKeDDo"
                ></iframe> -->
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Problem Identification</h3>
      </div>
    </div>
    <div class="green">
      <p>
        How is this problem currently being resolved in the market?
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques4" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(4)">
          Save
        </button>
        <button (click)="openPopup(4)" class="green-button" mat-button>
          Sample Answer
        </button>
      </div>
      <div
        style="z-index: 2"
        class="modal"
        tabindex="-1"
        role="dialog"
        [ngStyle]="{ display: popupDisplayStyles[4] }"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content mode">
            <div class="modal-header">
              <div style="float: right; color: white">
                <img
                  src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                  alt="close"
                  (click)="closePopup(4)"
                />
              </div>
              <h1
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-bottom: 3rem;
                "
                class="modal-title"
              >
                <!-- <i
                    class="fa fa-circle"
                    style="font-size: small; color: #00c4f4"
                    aria-hidden="true"
                  ></i> -->
                <span class="headi">SAMPLE ANSWER</span>
                <!-- <i
                    class="fa fa-circle"
                    style="font-size: small; color: #00c4f4"
                    aria-hidden="true"
                  ></i> -->
              </h1>
            </div>
            <div style="color: black">
              <div class="member" style="color: black">
                <p>
                  <!-- <strong -->
                    Most companies use traditional plastic packaging, which is not recyclable and persists in the environment.
                    <!-- </strong >-->
                  
                </p>
                <!-- <ul>
                  <li>Black &amp; Yellow cabs</li>
                  <li>Private Cab</li>
                  <li>Rent-a-Car Services(Avis, Hertz, etc.)</li>
                </ul> -->
              </div>
              <div class="container video">
                <div class="video">
                  <!-- <iframe
                    width="300"
                    src="https://www.youtube.com/embed/C91utiNU0cI"
                  ></iframe> -->
                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Startup Stage</h3>
      </div>
    </div>
    <div class="green">
      <p>
        What is the current stage of your venture? (Idea stage, Business Model
        stage, Proof-of-Concept, Client Pilot, Prototyping, Early-stage revenue,
        Growth-stage, Any Other)
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques5" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(5)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(5)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[5] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(5)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
              <span class="headi">SAMPLE ANSWER</span>
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
             
              <p>Early Stage Revenue</p>
              <p><br /></p>
            </div>
            <div class="container video">
              <div class="video">
                <!-- <iframe
                  width="300"
                  src="https://www.youtube.com/embed/Y2-5aPewZCA"
                ></iframe> -->
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Customer Segment</h3>
      </div>
    </div>
    <div class="green">
      <p>
        Who is your intended customer segment or target audience?
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques6" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(6)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(6)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[6] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(6)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
              <span class="headi">SAMPLE ANSWER</span>
              <!-- <i
                  class="fa fa-circle"
                  style="font-size: small; color: #00c4f4"
                  aria-hidden="true"
                ></i> -->
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              
              <p>E-commerce businesses and eco-conscious brands.
              </p>
              <p><br /></p>
            </div>
            <div class="container video">
              <div class="video">
                <!-- <iframe
                  width="300"
                  src="https://www.youtube.com/embed/rlPVu0EzGAY"
                ></iframe> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Competitive Landscape</h3>
      </div>
    </div>
    <div class="green">
      <p>Who are your direct and indirect competitors?      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques7" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(7)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(7)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[7] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(7)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Similar brands or offerings, eg. Greenpack 
                Other alternatives, packaging companies, eg. Wrapo</p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Competitive Landscape</h3>
      </div>
    </div>
    <div class="green">
      <p>What differentiates your venture from these competitors? How does it improve upon existing solutions?
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques8" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(8)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(8)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[8] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(8)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Our packaging is 100% biodegradable and made from locally sourced materials, reducing carbon footprint.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Revenue Generation</h3>
      </div>
    </div>
    <div class="green">
      <p>How does the venture generate revenue? What are the future growth opportunities?

      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques9" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(9)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(9)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[9] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(9)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Eco-Friendly Products: The business offers a range of packaging solutions, including biodegradable and compostable options. <br>
                Online Sales & Subscription: Customers can purchase products online with the option for subscriptions, and premium custom branding.<br>
                Bulk Sales & Discounts: The company generates revenue through bulk orders, wholesale pricing, and discounts for large businesses.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Revenue Generation</h3>
      </div>
    </div>
    <div class="green">
      <p>What factors affect your costs and revenues?

      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques10" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(10)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(10)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[10] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(10)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Raw material prices, production costs, and demand fluctuations.
                Higher raw material costs could squeeze margins, so we focus on securing long-term supplier contracts.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- marketing strategy -->
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Marketing Strategy</h3>
      </div>
    </div>
    <div class="green">
      <p>What is your marketing strategy to reach your target audience & create demand for your product or service? (Mention any IP advantage, if any)


      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques11" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(11)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(11)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[11] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(11)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>We utilize social media campaigns, partnerships with eco-friendly brands, and industry trade shows.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Marketing Strategy</h3>
      </div>
    </div>
    <div class="green">
      <p>What channels do you plan to use? 
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques12" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(12)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(12)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[12] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(12)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>LinkedIn, Instagram, and sustainability-focused online platforms.


              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- innovation impact -->
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Innovation Impact</h3>
      </div>
    </div>
    <div class="green">
      <p>What is the expected impact of your innovation on the market or society?



      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques13" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(13)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(13)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[13] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(13)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>We aim to reduce plastic waste and promote sustainable practices among businesses significantly.

              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- addditional -->
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Additional</h3>
      </div>
    </div>
    <div class="green">
      <p>Please share any additional information or insights about your startup. </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques14" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(14)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(14)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[14] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(14)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>We are currently seeking partnerships with larger e-commerce platforms to scale our production and reach.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Additional</h3>
      </div>
    </div>
    <div class="green">
      <p>What pain points or challenges are you facing in your startup journey?
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques15" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(15)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(15)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[15] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(15)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Access to funding for scaling production and navigating regulatory requirements in the GCC.
              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Additional</h3>
      </div>
    </div>
    <div class="green">
      <p>What support or guidance do you seek by participating in the competition?
      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques16" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(16)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(16)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[16] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(16)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>Mentorship in market entry strategies, networking opportunities with potential partners, and insights into GCC market dynamics.

              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div>
      <div class="description">
        <img class="pin" src="assets/images/pin2.png" alt="" />
        <h3>Additional</h3>
      </div>
    </div>
    <div class="green">
      <p>What are your expansion plans in the GCC?

      </p>
      <div class="inputs">
        <textarea [formControl]="myForm.controls.ques17" rows="5"> </textarea>
        <button class="green-button" mat-button (click)="onquesN(17)">
          Save
        </button>
        <button class="green-button" mat-button (click)="openPopup(17)">
          Sample Answer
        </button>
      </div>
    </div>
    <div
      style="z-index: 2"
      class="modal"
      tabindex="-1"
      role="dialog"
      [ngStyle]="{ display: popupDisplayStyles[17] }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content mode">
          <div class="modal-header">
            <div style="float: right; color: white">
              <img
                src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
                alt="close"
                (click)="closePopup(17)"
              />
            </div>
            <h1
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 3rem;
              "
              class="modal-title"
            >
              <span class="headi">SAMPLE ANSWER</span>
            </h1>
          </div>
          <div style="color: black">
            <div class="member" style="color: black">
              <p>We aim to establish partnerships with local businesses and explore distribution channels across the region to increase our market presence.

              </p>
            </div>
            <div class="container video">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="center">
    <button class="btn inverse" mat-button (click)="onsubmit(!showSkip)">
      Submit
    </button>
    <button
      class="btn inverse"
      mat-button
      *ngIf="showSkip"
      (click)="onsubmit(true)"
    >
      Skip For Now
    </button>
  </div>
</form>
